module.exports = __webpack_public_path__ + "static/15-79d1c95c8f66c117bfe05ce5c7162110.png";